/* @meta
layout: room-pink
*/
import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
  setRoomsCleared,
  setModalStatus,
  setGameFinished,
  setSelectedRoom,
  setStartButtonUrl,
} from '../../modules/gameProgress'
import { openQuizModal } from '../../modules/quizzes'

import { withStatechart } from 'react-automata'
import { clickItem, removeItemsForRoom } from '../../modules/itemInteractions'
import { getRoomButtonText } from '../../helpers'
import { connectAudio } from '../../components/AudioProvider'
import Preload from '../../components/Preload'
import RoomPageBase from '../../components/RoomPageBase'
import BedroomRoomDesktop from './_BedroomRoom.desktop'
import BedroomRoomMobile from './_BedroomRoom.mobile'
import StyledDesktop from './_StyledDesktop'
import StyledMobile from './_StyledMobile'
import StyledPreloadBar from './_StyledPreloadBar'
import StyledTipTracker from './_StyledTipTracker'
import StyledFooter from './_StyledFooter'

// Preload items
import CharacterKeoniForwardImage from '../../assets/images/character--keoni-forward@3x.png'
import CharacterPluggyForwardArmDownImage from '../../assets/images/character--pluggy-forward-arm-down@3x.png'
import IndicatorArrowDownImage from '../../assets/images/indicator--arrow-down@3x.png'
import WallsPinkImage from '../../assets/images/bedroom/walls--pink@3x.png'
import LightsOutImage from '../../assets/images/bedroom/lights-out@3x.png'
import BedroomCatFrame1Image from '../../assets/images/bedroom/item--cat--f1@3x.png'
import BedroomCatFrame2Image from '../../assets/images/bedroom/item--cat--f2@3x.png'
import BedroomCatFrame3Image from '../../assets/images/bedroom/item--cat--f3@3x.png'
import BedroomCatFrame4Image from '../../assets/images/bedroom/item--cat--f4@3x.png'
import BedroomCatFrame5Image from '../../assets/images/bedroom/item--cat--f5@3x.png'
import BedroomCatFrame6Image from '../../assets/images/bedroom/item--cat--f6@3x.png'
import BedroomCatFrame7Image from '../../assets/images/bedroom/item--cat--f7@3x.png'
import BedroomCatFrame8Image from '../../assets/images/bedroom/item--cat--f8@3x.png'
import BedroomCatFrame9Image from '../../assets/images/bedroom/item--cat--f9@3x.png'
import BedroomChairImage from '../../assets/images/bedroom/item--chair@3x.png'
import BedroomChloeFrame1Image from '../../assets/images/bedroom/item--cat--f1@3x.png'
import BedroomChloeFrame2Image from '../../assets/images/bedroom/item--cat--f2@3x.png'
import BedroomChloeFrame3Image from '../../assets/images/bedroom/item--cat--f3@3x.png'
import BedroomChloeFrame4Image from '../../assets/images/bedroom/item--cat--f4@3x.png'
import BedroomChloeFrame5Image from '../../assets/images/bedroom/item--cat--f5@3x.png'
import BedroomChloeFrame6Image from '../../assets/images/bedroom/item--cat--f6@3x.png'
import BedroomChloeFrame7Image from '../../assets/images/bedroom/item--cat--f7@3x.png'
import BedroomChloeFrame8Image from '../../assets/images/bedroom/item--cat--f8@3x.png'
import BedroomChloeFrame9Image from '../../assets/images/bedroom/item--cat--f9@3x.png'
import BedroomDeskImage from '../../assets/images/bedroom/item--desk@3x.png'
import BedroomDoorImage from '../../assets/images/bedroom/item--door@3x.png'
import BedroomFanImage from '../../assets/images/bedroom/item--fan@3x.png'
import BedroomLampImage from '../../assets/images/bedroom/item--lamp@3x.png'
import BedroomLaptopImage from '../../assets/images/bedroom/item--laptop@3x.png'
import BedroomPlantImage from '../../assets/images/bedroom/item--plant@3x.png'
import BedroomRugImage from '../../assets/images/bedroom/item--rug@3x.png'
import BedroomSwitchImage from '../../assets/images/bedroom/item--switch@3x.png'
import BedroomWindowFrame1Image from '../../assets/images/bedroom/item--window--f1@3x.png'
import BedroomWindowFrame2Image from '../../assets/images/bedroom/item--window--f2@3x.png'
import BedroomWindowFrame3Image from '../../assets/images/bedroom/item--window--f3@3x.png'
import BedroomWindowFrame4Image from '../../assets/images/bedroom/item--window--f4@3x.png'
import BedroomWindowFrame5Image from '../../assets/images/bedroom/item--window--f5@3x.png'
import BedroomWindowFrame6Image from '../../assets/images/bedroom/item--window--f6@3x.png'
import BedroomWindowFrame7Image from '../../assets/images/bedroom/item--window--f7@3x.png'
import BedroomWindowFrame8Image from '../../assets/images/bedroom/item--window--f8@3x.png'
import BedroomSpeakersFrame1Image from '../../assets/images/bedroom/item--speakers--f1@3x.png'
import BedroomSpeakersFrame2Image from '../../assets/images/bedroom/item--speakers--f2@3x.png'

const preloadItems = [
  CharacterKeoniForwardImage,
  CharacterPluggyForwardArmDownImage,
  IndicatorArrowDownImage,
  WallsPinkImage,
  LightsOutImage,
  BedroomCatFrame1Image,
  BedroomCatFrame2Image,
  BedroomCatFrame3Image,
  BedroomCatFrame4Image,
  BedroomCatFrame5Image,
  BedroomCatFrame6Image,
  BedroomCatFrame7Image,
  BedroomCatFrame8Image,
  BedroomCatFrame9Image,
  BedroomChairImage,
  BedroomChloeFrame1Image,
  BedroomChloeFrame2Image,
  BedroomChloeFrame3Image,
  BedroomChloeFrame4Image,
  BedroomChloeFrame5Image,
  BedroomChloeFrame6Image,
  BedroomChloeFrame7Image,
  BedroomChloeFrame8Image,
  BedroomChloeFrame9Image,
  BedroomDeskImage,
  BedroomDoorImage,
  BedroomFanImage,
  BedroomLampImage,
  BedroomLaptopImage,
  BedroomPlantImage,
  BedroomRugImage,
  BedroomSwitchImage,
  BedroomWindowFrame1Image,
  BedroomWindowFrame2Image,
  BedroomWindowFrame3Image,
  BedroomWindowFrame4Image,
  BedroomWindowFrame5Image,
  BedroomWindowFrame6Image,
  BedroomWindowFrame7Image,
  BedroomWindowFrame8Image,
  BedroomSpeakersFrame1Image,
  BedroomSpeakersFrame2Image,
]

const mapStateToProps = (state) => ({
  firstName: state.player.firstName,
  clickedItems: state.itemInteractions.clickedItems,
  roomsCleared: state.gameProgress.roomsCleared,
  gameFinished: state.gameProgress.gameFinished,
  modalIsActive: state.gameProgress.modalIsActive,
  isOver18: state.player.isOver18,
  clearedQuizRoomIds: state.quizzes.clearedQuizRoomIds,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      clickItem,
      removeItemsForRoom,
      setRoomsCleared,
      setGameFinished,
      setModalStatus,
      setSelectedRoom,
      setStartButtonUrl,
      openQuizModal,
    },
    dispatch,
  )

const statechartOnItems = {
  NEXT: 'items',
  FAN: 'fan',
  SWITCH: 'switch',
  WINDOW: 'window',
  LAMP: 'lamp',
  SPEAKERS: 'speakers',
}

const statechart = {
  initial: 'init',
  states: {
    init: {
      on: {
        NEXT: 'guide',
      },
    },

    guide: {
      on: {
        ...statechartOnItems,
      },
    },

    items: {
      on: {
        ...statechartOnItems,
      },
    },

    fan: {
      on: {
        ...statechartOnItems,
      },
    },

    window: {
      on: {
        ...statechartOnItems,
      },
    },

    switch: {
      on: {
        ...statechartOnItems,
      },
    },

    lamp: {
      on: {
        ...statechartOnItems,
      },
    },

    speakers: {
      on: {
        ...statechartOnItems,
      },
    },
  },
}

class BedroomPage extends RoomPageBase {
  static roomName = 'Bedroom'

  static roomId = 'bedroom'

  static validItems = ['fan', 'window', 'switch', 'lamp', 'speakers']

  static tipsCount = 5

  constructor() {
    super()

    this.state = {
      switchWasClicked: false,
      windowWasClicked: false,
    }
  }

  componentDidMount() {
    RoomPageBase.prototype.componentDidMount.bind(this)()
    this.props.removeItemsForRoom(this.constructor.roomId)
  }

  onPreloadLoaded() {
    setTimeout(() => this.props.transition('NEXT'), 1000)
  }

  onItemClick(id) {
    let fullItemId = `${this.constructor.roomId}__${id}`

    const playSound = () => {
      if (!this.props.clickedItems.includes(fullItemId)) {
        this.props.audio.xyl1.play()
      }
    }

    if (id === 'switch') this.setState({ switchWasClicked: true })

    super.onItemClick(id)
    if (this.constructor.validItems.includes(id)) playSound()
  }

  getPendingHighlightIds() {
    const { machineState } = this.props

    switch (machineState) {
      // case 'init':
      // case 'guide':
      // case 'itemsLimited':
      //   return ['powerStrip']

      default:
        const clickedItems = this.getClickedItemsForRoom()
        return this.constructor.validItems.filter(
          (item) => !clickedItems.includes(item),
        )
    }
  }

  getSuccessHighlightIds() {
    return this.getClickedItemsForRoom()
  }

  getAnimateIds() {
    const ids = []

    const clickedItems = this.getClickedItemsForRoom()
    if (clickedItems.includes('window')) ids.push('window')

    return ids
  }

  shouldBlock() {
    const { machineState } = this.props

    switch (machineState) {
      case 'items':
        return this.clickedAllItems()

      case 'guide':
      case 'fan':
      case 'lamp':
      case 'window':
      case 'switch':
      case 'speakers':
        return true
    }
  }

  render() {
    const { switchWasClicked } = this.state
    const {
      data,
      transition,
      roomsCleared,
      modalIsActive,
      setGameFinished,
      setModalStatus,
      setRoomsCleared,
      gameFinished,
      setSelectedRoom,
      setStartButtonUrl,
      isOver18,
      openQuizModal,
      clearedQuizRoomIds,
    } = this.props
    const pendingHighlightIds = this.getPendingHighlightIds()
    const successHighlightIds = this.getSuccessHighlightIds()
    const animateIds = this.getAnimateIds()

    const roomProgressData = {
      roomId: 'bedroom',
      roomsCleared,
      modalIsActive,
      setGameFinished,
      setModalStatus,
      setRoomsCleared,
      gameFinished,
      setSelectedRoom,
      setStartButtonUrl,
      isOver18,
      openQuizModal,
      clearedQuizRoomIds,
    }
    let buttonText = getRoomButtonText()

    return [
      <StyledTipTracker
        openedTipsCount={this.getOpenedTipsCount()}
        roomName={this.constructor.roomName}
        tipsCount={this.constructor.tipsCount}
        shakasEarned={clearedQuizRoomIds.length}
        key="bedroom__tip-tracker"
        isOver18={isOver18}
        colorScheme="red"
      />,
      <StyledFooter
        key="bedroom__footer"
        roomName={this.constructor.roomName}
      />,
      <Preload
        items={preloadItems}
        onLoaded={this.onPreloadLoaded.bind(this)}
        key="bedroom__preload"
      >
        {(loaded, percentDone) =>
          loaded ? (
            [
              <StyledMobile key="bedroom__mobile">
                <BedroomRoomMobile
                  animateIds={animateIds}
                  clickedAllItems={this.clickedAllItems()}
                  data={data}
                  onItemClick={this.onItemClick.bind(this)}
                  pendingHighlightIds={pendingHighlightIds}
                  renderTip={this.renderTip.bind(this)}
                  shouldBlock={this.shouldBlock()}
                  successHighlightIds={successHighlightIds}
                  switchWasClicked={switchWasClicked}
                  transition={transition}
                  onRoomClear={this.onRoomClear}
                  roomProgressData={roomProgressData}
                  buttonText={buttonText}
                />
              </StyledMobile>,
              <StyledDesktop key="bedroom__desktop">
                <BedroomRoomDesktop
                  animateIds={animateIds}
                  clickedAllItems={this.clickedAllItems()}
                  data={data}
                  onItemClick={this.onItemClick.bind(this)}
                  pendingHighlightIds={pendingHighlightIds}
                  renderTip={this.renderTip.bind(this)}
                  shouldBlock={this.shouldBlock()}
                  successHighlightIds={successHighlightIds}
                  switchWasClicked={switchWasClicked}
                  transition={transition}
                  onRoomClear={this.onRoomClear}
                  roomProgressData={roomProgressData}
                  buttonText={buttonText}
                />
              </StyledDesktop>,
            ]
          ) : (
            <StyledPreloadBar percentDone={percentDone} colorScheme="red" />
          )
        }
      </Preload>,
    ]
  }
}

const BedroomPageConnected = connect(
  mapStateToProps,
  mapDispatchToProps,
)(connectAudio()(withStatechart(statechart)(BedroomPage)))

export default BedroomPageConnected

export const pageQuery = graphql`
  query allBedroomTips {
    allMarkdownRemark(
      filter: {
        frontmatter: { type: { eq: "tip" }, roomId: { eq: "bedroom" } }
      }
    ) {
      edges {
        node {
          html
          frontmatter {
            id
            title
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/bedroom/index.js